<template>
  <div class="class-rank">
    <el-table v-if="classRankVal != ''" :data="classRankStudentList" style="width: 100%" height="calc(100vh - 260px)">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.scoreRankContrastDTOList" border style="width: 100%; margin: 0 10px;">
            <el-table-column prop="studentName" label="姓名"></el-table-column>
            <el-table-column prop="studentNumber" label="学号"></el-table-column>
            <el-table-column v-for="(item, index) in classRankCourseList" :key="index" :label="item">
              <template slot-scope="{ row }">
                <span v-if="row.courseInfoList.find((courseItem) => courseItem.courseName === item)">
                  {{
                    row.courseInfoList &&
                    row.courseInfoList.find((courseItem) => courseItem.courseName === item)
                      ?.score
                  }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalScore" label="总分"></el-table-column>
            <el-table-column prop="avgScore" label="平均分"></el-table-column>
            <el-table-column prop="classRank" label="班级排名"></el-table-column>
            <el-table-column prop="gradeRank" label="年级排名"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="班级" prop="className">
      </el-table-column>
      <!-- <el-table-column label="名次" prop="rank">
      </el-table-column> -->
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- <el-button type="success" size="small">查看视图</el-button> -->
            <el-button type="success" size="small" @click="copyStudentNames(scope.row)">复制名字</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="rank-text" v-else>请输入名次查询</div>
  </div>
</template>

<script>
export default {
  props: ['classRankVal', 'classRankStudentList', 'classRankCourseList'],
  data() {
    return {
      tableData: [{
        name: "一班",
        rank: 1,
        studentData: [{
          name: "张三",
          number: 's001',
          rank: 1,
          score: 100
        },
        {
          name: "张四",
          number: 's002',
          rank: 2,
          score: 99
        }]
      },
      {
        name: "二班",
        rank: 2,
        studentData: [{
          name: "张三",
          number: 's001',
          rank: 1,
          score: 100
        },
        {
          name: "张四",
          number: 's002',
          rank: 2,
          score: 99
        }]
      },]
    }
  },
  methods: {
    // 各班排名复制名字
    copyStudentNames(row) {
      const names = row.scoreRankContrastDTOList.map(student => student.studentName).join(', ');

      // 如果 navigator.clipboard 存在并且有 writeText 方法，则使用它
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(names).then(() => {
          this.$message.success('学生姓名已复制到剪贴板1');
        }).catch(err => {
          console.error('复制到剪贴板失败', err);
        });
      } else { // 否则使用备用方案
        const tempInput = document.createElement("input");
        tempInput.value = names;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
          document.execCommand('copy');
          this.$message.success('学生姓名已复制到剪贴板');
        } catch (err) {
          console.error('复制到剪贴板失败', err);
        } finally {
          document.body.removeChild(tempInput);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import './classRank.scss';
</style>